import React from 'react';
import './EventTimeline.css';

import { toFriendlyDateTimeString } from 'helpers/Formatter';
import { getCurrentLocale } from 'helpers/i18n';

const event_verbiage = verbiage =>
  verbiage.map((event, index) => (
    <p
      style={{
        color: 'rgba(78, 78, 78, 0.54)',
        fontSize: '12px',
        marginBottom: '3px',
        whiteSpace: 'pre-wrap',
      }}
      key={index}
    >
      {event}
    </p>
  ));

export default props => (
  <div className="timeline">
    <ul>
      {props.events.map(function(event, index) {
        let color = 'red';
        if (index % 2) {
          color = 'light-red';
        }
        return (
          <li key={index}>
            <div className={`bullet ${color}`} />
            <div className="time">
              {toFriendlyDateTimeString(event.time, { language: getCurrentLocale() })}
            </div>
            <div className="desc">
              <h3 style={{ fontSize: '14px', marginBottom: '5px' }}>{event.title}</h3>
              {event_verbiage(event.verbiage)}
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);
